import { render, staticRenderFns } from "./McpWheelLoader.vue?vue&type=template&id=d617c318&"
import script from "./McpWheelLoader.vue?vue&type=script&lang=js&"
export * from "./McpWheelLoader.vue?vue&type=script&lang=js&"
import style0 from "./McpWheelLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports